import React, { useState } from 'react';

export default function BarreRecherche({ valeurInitiale = '', onRechercher }) {
  const [q, setQ] = useState(valeurInitiale);

  function soumettre(e) {
    e.preventDefault();
    onRechercher?.(q);
  }

  return (
    <form onSubmit={soumettre} className="w-full">
      <div className="flex items-center overflow-hidden rounded-2xl border border-gray-200 bg-gray-50">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Rechercher un produit, une catégorie..."
          className="w-full bg-transparent px-5 py-4 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none"
        />
        <button type="submit" className="px-5 py-4 text-sm font-semibold text-gray-700 hover:bg-gray-100">
          Rechercher
        </button>
      </div>
    </form>
  );
}
